<template>
  <v-container style="min-height: calc(100vh - 80px);" class="my-5">
    <v-row v-if="false">
      <v-col cols="12" md="8">
        <v-btn
          text
          class="text-capitalize"
          href="#">
          <v-icon left>mdi-text-box-check-outline</v-icon> Daftar tugas
        </v-btn>
        <v-btn
          text
          class="text-capitalize"
          href="#">
          <v-icon left>mdi-folder-text</v-icon> Untuk diperiksa
        </v-btn>
        <v-btn
          text
          class="text-capitalize"
          href="#">
          <v-icon left>mdi-calendar-month</v-icon> Kalender
        </v-btn>
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          dense
          prepend-inner-icon="search"
          v-model="paramclass.keyword"
          label="Nama kelas"
          name="keyword">
        </v-text-field>
      </v-col>
    </v-row>
    <v-row v-if="datalist.length > 0">
      <v-col
        class="d-flex" style="flex-direction:column"
        cols="12"
        md="4"
        v-for="(kelas, i) in datalist"
        :key="i">
        <v-card
          class="flex-grow-1"
          outlined>
          <v-img
            height="80px"
            :lazy-src="require('../../assets/default.jpg')"
            :src="api + '/upload/kelas/' + kelas.bgimg_class">
            <v-app-bar
              dark
              flat
              color="rgba(0, 0, 0, 0)">
              <v-toolbar-title class="title pl-0">
                <router-link
                  class="white--text text-decoration-none"
                  :to="{ name: 'DetailclassMhs', query: { class: kelas.id_class } }">
                  {{ kelas.nama_class }}
                </router-link>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-menu
                offset-y
                bottom
                left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    exact>
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    @click="cancelClass(kelas)">
                    <v-list-item-title>Keluar kelas</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-app-bar>
          </v-img>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="12">
                <div class="font-weight-bold">Semester {{ kelas.semester_class }}</div>
                <div class="font-weight-bold">{{ kelas.matkul_class }}</div>
                <div class="font-weight-bold">Kelas: {{ kelas.mhs_class }}</div>
                <div class="font-weight-bold">T.A {{ kelas.year_class }}</div>
              </v-col>
              <v-col cols="12" md="12" class="py-0" v-if="false">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="12" md="12" v-if="false">
                List uncoming
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="datalist.length <= 0" justify="center">
      <v-col
        cols="12"
        md="12"
        class="text-center black--text">
        <v-img
          contain
          max-width="200"
          class="ma-auto"
          :src="require('../../assets/datanotfound.png')">
        </v-img>
        <h3 class="text-md-h5">
          Anda belum memiliki kelas yang aktif?
        </h3>
        <h3 class="text-md-h5">
          Ingin gabung kelas?
        </h3>
        <v-btn
          class="ma-2"
          outlined
          large
          fab
          color="primary"
          :to="{ name: 'JoinclassMhs' }">
          <v-icon large>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <infinite-loading :identifier="infiniteId" @infinite="getClass">
          <div slot="spinner">Loading...</div>
          <div slot="no-more"></div>
          <div slot="no-results"></div>
        </infinite-loading>
      </v-col>
    </v-row>
    <v-dialog
      v-model="dmodal.cancel"
      max-width="450px">
      <v-card v-if="dmodaldata.cancel">
        <v-card-title>
          <span>Keluar kelas</span>
          <v-spacer></v-spacer>
          <v-icon
            class="float-right class-cursor"
            color="red"
            @click="dmodal.cancel = false">
            mdi-close-box
          </v-icon>
        </v-card-title>
        <v-card-text>
          <alertsp :alertdata="alertupdate"></alertsp>
          <div class="font-weight-bold">
            Apakah anda yakin ingin keluar dari kelas ini? <br>
            <b>{{ dmodaldata.cancel.nama_class }}</b>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            class="ml-2"
            small
            color="primary"
            :loading="loading.cancel"
            :disabled="loading.cancel"
            @click="confirmCancel(dmodaldata.cancel)">
            Keluar kelas
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import InfiniteLoading from 'vue-infinite-loading';
import { mapState } from 'vuex';

export default {
  name: 'ListclassMhs',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      check: false,
      cancel: false,
    },
    api: process.env.VUE_APP_API,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    publickey: '123',
    datalist: [],
    listcategory: ['job-fair', 'motivation'],
    panduan: null,
    paramclass: {
      keyword: '',
      limit: 15,
      offset: 0,
    },
    check: {
      reference: '',
    },
    formcheck: {
      valid: false,
    },
    dmodal: {
      cancel: false,
    },
    dmodaldata: {
      cancel: null,
    },
    rules: {
      required: (value) => !!value || 'Required.',
    },
    hasil: {
      headers: [
        { text: 'Tahun', value: 'tahun_prestasi' },
        { text: 'Peringkat', value: 'juara_prestasi' },
        { text: 'Tingkat', value: 'tingkat_prestasi' },
      ],
      data: [],
    },
    infiniteId: +new Date(),
  }),
  mounted() {
    // this.getClass();
    if (this.$route.query.reference && this.$route.query.reference !== '') {
      this.check.reference = this.$route.query.reference;
    }
  },
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  methods: {
    confirmCancel(item) {
      // console.log(item);
      this.alertupdate.show = false;
      if (this.tokenscr) {
        this.loading.cancel = true;
        this.axios
          .delete(
            this.api + '/api/kelas/student/out/' + item.id_class,
            {
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              console.log(resdata);
              if (resdata.error === false) {
                this.alertupdate.show = true;
                this.alertupdate.type = 'success';
                this.alertupdate.text = 'Anda berhsil keluar dari kelas "' + item.nama_class + '"';
                this.getClassFilter();
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = resdata.message;
              }
            } else {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
            }
            this.loading.cancel = false;
          })
          .catch((error) => {
            console.log(error);
            this.alertupdate.show = true;
            this.alertupdate.type = 'error';
            this.alertupdate.text = 'Internal services error!';
            this.loading.cancel = false;
          });
      } else {
        this.alertupdate.show = true;
        this.alertupdate.type = 'error';
        this.alertupdate.text = 'Invalid token!';
      }
    },
    cancelClass(item) {
      // console.log(item);
      this.dmodal.cancel = true;
      this.dmodaldata.cancel = JSON.parse(JSON.stringify(item));
    },
    getClassFilter() {
      this.paramclass.offset = 0;
      this.datalist = [];
      this.infiniteId += 1;
    },
    getClass($state) {
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/kelas/student',
            {
              params: this.paramclass,
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                if (resdata.data.length > 0) {
                  this.paramclass.offset += this.paramclass.limit;
                  this.datalist.push(...resdata.data);
                  if (this.datalist.length < this.paramclass.offset) {
                    $state.complete();
                  } else {
                    $state.loaded();
                  }
                } else {
                  $state.complete();
                }
              }
            }
            // this.loading.check = false;
          })
          .catch((error) => {
            console.log(error);
            // this.loading.check = false;
          });
      }
    },
  },
  components: {
    Alertsp,
    InfiniteLoading,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
